import { useNavigate } from 'react-router-dom';
import { useActivity, type ActivityEntry } from '../lib/pipeline.js';
import { useT } from '../lib/i18n.js';

/**
 * Die Aktivitätsleiste (README §6.2): was gerade läuft, was als Nächstes
 * ansteht, was zuletzt passiert ist -- über alle Projekte.
 */
export function ActivityDock({ onClose }: { onClose: () => void }) {
  const t = useT();
  const { now, next, recent } = useActivity();

  return (
    <aside className="dock" aria-label={t('Aktivität')}>
      <div className="row">
        <span style={{ fontSize: 15, fontWeight: 600 }} className="grow">{t('Aktivität')}</span>
        <button type="button" className="icon-btn" onClick={onClose} aria-label={t('Schließen')}>✕</button>
      </div>
      <Group title={t('Läuft gerade')} items={now} empty={t('Gerade arbeitet nichts.')} />
      <Group title={t('Als Nächstes')} items={next} empty={t('Nichts offen.')} />
      <Group title={t('Zuletzt')} items={recent} empty={t('Noch nichts passiert.')} />
    </aside>
  );
}

function Group({ title, items, empty }: { title: string; items: ActivityEntry[]; empty: string }) {
  return (
    <div className="col" style={{ gap: 8 }}>
      <div className="section-label">{title}</div>
      {items.length === 0 && <div className="dim" style={{ fontSize: 13 }}>{empty}</div>}
      {items.map((e) => <Entry key={e.key} e={e} />)}
    </div>
  );
}

function Entry({ e }: { e: ActivityEntry }) {
  const navigate = useNavigate();
  return (
    <div className="dock-item">
      <span className={`dock-glyph tone-${e.tone}`}>{e.glyph}</span>
      <div className="grow col" style={{ gap: 3 }}>
        <span className="truncate" style={{ fontSize: 13.5, fontWeight: 500 }}>{e.title}</span>
        <span className="dim" style={{ fontSize: 12, lineHeight: 1.4 }}>{e.meta}</span>
        {typeof e.progress === 'number' && (
          <div className="bar" style={{ marginTop: 4 }}>
            <div className="bar-fill" style={{ width: `${e.progress}%` }} />
          </div>
        )}
        {e.link && (
          <button type="button" className="btn-link" style={{ alignSelf: 'flex-start', marginTop: 2, fontSize: 12.5 }} onClick={() => navigate(e.link!.to)}>
            {e.link.label}
          </button>
        )}
      </div>
    </div>
  );
}
